module.exports = __webpack_public_path__ + "img/peru.45b647f8.png";